/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    'accountId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'fetchStatus'?: JobFetchStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'normalizationStatus'?: JobNormalizationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'executionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'successFetchDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    'successNormalizationDate'?: string | null;
}

export const JobFetchStatusEnum = {
    success: 'SUCCESS',
    failure: 'FAILURE'
} as const;

export type JobFetchStatusEnum = typeof JobFetchStatusEnum[keyof typeof JobFetchStatusEnum];
export const JobNormalizationStatusEnum = {
    success: 'SUCCESS',
    failure: 'FAILURE'
} as const;

export type JobNormalizationStatusEnum = typeof JobNormalizationStatusEnum[keyof typeof JobNormalizationStatusEnum];


